<template>
  <div class="filter">
    <sc-autocomplete
      class="input-filter"
      v-model="name"
      :data="filterIntegrationArray"
      placeholder="Filtre pelo nome do aplicativo"
      icon="search"
      clearable
    >
      <template #empty>No results found</template>
    </sc-autocomplete>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import { ScAutocomplete } from "@intelipost-js/secure-components";

const { mapState, mapActions } = createNamespacedHelpers("integrations/integrationsHome");

export default {
  data() {
    return {
      name: "",
      allAppsAvailable: [],
      allAppsFiltered: [],
    };
  },

  components: {
    ScAutocomplete,
  },

  props: {
    appList: {
      type: Array,
      required: true,
    },
  },

  computed: {

    ...mapState([
      "appNameFilterFieldValue",
      "appsWithoutFilter",
    ]),


    filterIntegrationArray() {
      if (this.appsWithoutFilter) {
        const integrationsName = [];

        this.appsWithoutFilter.map((app) => integrationsName.push(app.name));

        const appNameFiltered = integrationsName.filter(
          (app) =>
            app.toString().toLowerCase().indexOf(this.name.toLowerCase()) >= 0
        );

        const response = this.appsWithoutFilter.filter((app) =>
          appNameFiltered.includes(app.name)
        );

        if(response.length > 0){
          this.setFilteredAppList(response);
        }

        this.allAppsFiltered = appNameFiltered;
        return this.allAppsFiltered
      }

      return [];
    },

  },

  methods: {
    ...mapActions(["setFilteredAppList"]),
  },

  mounted() {
    this.name = this.appNameFilterFieldValue
  },

};
</script>

<style>
.filter {
  width: 200%;
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/components/app-filter/app-name-filter-field/AppNameFilterField.vue?ba3c6006